import { decodeTime } from "ulid";
/**
 * Sticker Class
 */
export class Sticker {
    #collection;
    id;
    /**
     * Construct Sticker
     * @param collection Collection
     * @param id Sticker Id
     */
    constructor(collection, id) {
        this.#collection = collection;
        this.id = id;
    }
    /**
     * Convert to string
     * @returns String
     */
    toString() {
        return `:${this.id}:`;
    }
    /**
     * Whether this object exists
     */
    get $exists() {
        return !!this.#collection.getUnderlyingObject(this.id).id;
    }
    /**
     * Time when this sticker was created
     */
    get createdAt() {
        return new Date(decodeTime(this.id));
    }
    /**
     * Information about the parent of this sticker
     */
    get parent() {
        return this.#collection.getUnderlyingObject(this.id).parent;
    }
    /**
     * Creator of the sticker
     */
    get creator() {
        return this.#collection.client.users.get(this.#collection.getUnderlyingObject(this.id).creatorId);
    }
    /**
     * Name
     */
    get name() {
        return this.#collection.getUnderlyingObject(this.id).name;
    }
    /**
     * Whether the sticker is marked as mature
     */
    get mature() {
        return this.#collection.getUnderlyingObject(this.id).nsfw;
    }
    /**
     * URL to sticker
     */
    get url() {
        return `${this.#collection.client.configuration?.features.autumn.url}/stickers/${this.id}`;
    }
    /**
     * Delete Sticker
     */
    async delete() {
        await this.#collection.client.api.delete(`/custom/sticker/${this.id}`);
        const sticker = this.#collection.getUnderlyingObject(this.id);
        if (sticker) {
            this.#collection.client.emit("stickerDelete", sticker);
            this.#collection.delete(this.id);
        }
    }
}
